import { FLAGS } from '@gozoki/feature-flags'
import { FeatureRouteGuard, RightsRouteGuard } from '~/components/route-guards'
import type { PermissionRequirement } from '~/utils/rbac'

/** Gardes des routes Logistique : flag `logistique`, puis droit v2 demandé (`route-guards.tsx`). */
export function LogisticsRouteGuard({
  permission,
  children,
}: React.PropsWithChildren<{ permission: PermissionRequirement }>) {
  return (
    <FeatureRouteGuard flag={FLAGS.logistique}>
      <RightsRouteGuard permission={permission}>{children}</RightsRouteGuard>
    </FeatureRouteGuard>
  )
}
